// JobListing.js
import React from "react";
import JobCategory from "./Job.category";
import { jobCategoryPlans } from "../assets/plan";

const JobListing = ({
  categorySelection,
  setCategorySelection,
  setJobProfile,
  jobProfile,
  loggedinUser,
  setPaymentReference,
  setJobType,
  close,
}) => {
  const handleCategorySelection = (planName) => {
    setCategorySelection(planName);
    setJobType(planName);
    setJobProfile({ ...jobProfile, jobType: planName });
    if (planName === "Draft") {
      setPaymentReference("N/A");
      close();
    }
  };

  return (
    <section className="">
      <div className="flex items-start justify-center flex-wrap my-4 gap-4">
        {jobCategoryPlans.map((eachPlan, index) => (
          <div className="flex items-center justify-center gap-5 h-fit" key={index}>
            <JobCategory
              plan_name={eachPlan.planName}
              plan_price={eachPlan.credits}
              plan_benefits={eachPlan.benefits}
              success_handler={handleCategorySelection}
              categorySelection={categorySelection}
              setCategorySelection={setCategorySelection}
              setPaymentReference={setPaymentReference}
              setJobType={setJobType}
              close={close}
              loggedinUser={loggedinUser}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default JobListing;




// // JobListing.js
// import React from "react";
// import { jobCategoryPlans } from "../assets/plan";

// /**
//  * Small "reach" indicator — three signal bars, filled according to tier index.
//  * Ties the visual language directly to what these plans actually sell:
//  * how far a job posting reaches on the board.
//  */
// const ReachBars = ({ level, tone }) => (
//   <div className="flex items-end gap-[3px] h-4" aria-hidden="true">
//     {[0, 1, 2].map((i) => (
//       <span
//         key={i}
//         className={`w-[4px] rounded-sm transition-colors ${
//           i <= level ? tone : "bg-slate-200"
//         }`}
//         style={{ height: `${6 + i * 5}px` }}
//       />
//     ))}
//   </div>
// );

// /**
//  * Miniature preview of how the job posting appears on the board at this tier.
//  * Standard = a normal card in the feed. Featured = pinned, bordered, badge visible.
//  * This is the signature element: instead of abstract checkmarks, each plan
//  * shows its real-world outcome.
//  */
// const ListingPreview = ({ tier }) => {
//   const base = "rounded-lg border px-3 py-2.5 text-left w-full";
//   if (tier === "featured") {
//     return (
//       <div className={`${base} border-amber-300 bg-amber-50 relative`}>
//         <span className="absolute -top-2 left-3 bg-amber-400 text-amber-950 text-[10px] font-semibold px-2 py-0.5 rounded-full">
//           Pinned
//         </span>
//         <div className="h-2 w-20 rounded bg-amber-800/70 mb-1.5" />
//         <div className="h-1.5 w-28 rounded bg-amber-700/30" />
//         <p className="mt-2 text-[11px] font-medium text-amber-700">Top of every search</p>
//       </div>
//     );
//   }
//   return (
//     <div className={`${base} border-slate-200 bg-white`}>
//       <div className="h-2 w-20 rounded bg-slate-700 mb-1.5" />
//       <div className="h-1.5 w-28 rounded bg-slate-300" />
//       <p className="mt-2 text-[11px] font-medium text-emerald-600">Live in the feed</p>
//     </div>
//   );
// };

// const tierFromPlan = (planName = "") => {
//   const name = planName.toLowerCase();
//   if (name.includes("featur") || name.includes("premium") || name.includes("pro")) {
//     return "featured";
//   }
//   return "standard";
// };

// const CheckIcon = ({ className }) => (
//   <svg viewBox="0 0 20 20" fill="none" className={className} aria-hidden="true">
//     <path
//       d="M4 10.5l3.5 3.5L16 6"
//       stroke="currentColor"
//       strokeWidth="1.8"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// const PlanCard = ({ plan, isRecommended, isSelected, onSelect }) => {
//   const tier = tierFromPlan(plan.planName);
//   const barTone = isRecommended ? "bg-amber-400" : "bg-slate-700";
//   const buttonIsBlack = isSelected || isRecommended;

//   return (
//     <div
//       className={`relative flex w-full flex-col rounded-2xl p-6 transition-all duration-200 ${
//         isRecommended
//           ? "border-2 border-amber-400 bg-white shadow-[0_8px_30px_-12px_rgba(0,0,0,0.25)]"
//           : "border border-slate-200 bg-white hover:border-slate-300"
//       } ${isSelected ? "ring-2 ring-offset-2 ring-slate-900" : ""}`}
//     >
//       {isRecommended && (
//         <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-amber-400 px-3 py-1 text-[11px] font-semibold tracking-wide text-amber-950">
//           Most reach
//         </span>
//       )}

//       <div className="flex items-center justify-between">
//         <p className="font-mono text-[11px] uppercase tracking-widest text-slate-400">
//           Live listing
//         </p>
//         <ReachBars level={tier === "featured" ? 2 : 1} tone={barTone} />
//       </div>

//       <h3 className="mt-2 text-xl font-semibold text-slate-900">{plan.planName}</h3>

//       <div className="mt-3 flex items-baseline gap-1.5">
//         <span className="font-mono text-3xl font-semibold text-slate-900">{plan.credits}</span>
//         <span className="text-sm text-slate-400">credits</span>
//       </div>

//       <div className="mt-5">
//         <ListingPreview tier={tier} />
//       </div>

//       <ul className="mt-5 flex-1 space-y-2.5">
//         {(plan.benefits || []).map((benefit, i) => (
//           <li key={i} className="flex items-start gap-2 text-sm text-slate-600">
//             <CheckIcon
//               className={`mt-0.5 h-4 w-4 flex-shrink-0 ${
//                 isRecommended ? "text-amber-500" : "text-slate-400"
//               }`}
//             />
//             <span>{benefit}</span>
//           </li>
//         ))}
//       </ul>

//       <button
//         type="button"
//         onClick={() => onSelect(plan.planName)}
//         className={`mt-6 w-full rounded-xl py-2.5 text-sm font-semibold transition-colors ${
//           buttonIsBlack
//             ? "bg-slate-900 text-white hover:bg-slate-800"
//             : "bg-slate-100 text-slate-900 hover:bg-slate-200"
//         }`}
//       >
//         {isSelected ? "Selected" : `Choose ${plan.planName}`}
//       </button>
//     </div>
//   );
// };

// const JobListing = ({
//   categorySelection,
//   setCategorySelection,
//   setJobProfile,
//   jobProfile,
//   loggedinUser,
//   setPaymentReference,
//   setJobType,
//   close,
// }) => {
//   const handleCategorySelection = (planName) => {
//     setCategorySelection(planName);
//     setJobType(planName);
//     setJobProfile({ ...jobProfile, jobType: planName });
//   };

//   const middleIndex = Math.floor(jobCategoryPlans.length / 2);

//   return (
//     <section className="w-full py-2">
//       <div className="mx-auto max-w-2xl text-center mb-8">
//         <p className="font-mono text-xs uppercase tracking-widest text-slate-400 mb-2">
//           Post a job
//         </p>
//         <h2 className="text-2xl font-semibold text-slate-900">Choose how far your listing reaches</h2>
//         <p className="mt-2 text-sm text-slate-500">
//           Every plan publishes your job. The difference is visibility.
//         </p>
//       </div>

//       <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 items-stretch max-w-4xl mx-auto">
//         {jobCategoryPlans.map((eachPlan, index) => (
//           <PlanCard
//             key={eachPlan.planName ?? index}
//             plan={eachPlan}
//             isRecommended={jobCategoryPlans.length >= 3 && index === middleIndex}
//             isSelected={categorySelection === eachPlan.planName}
//             onSelect={handleCategorySelection}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default JobListing;